// `t` is passed as a parameter because this composable is used in async setup() contexts
// after await, where the Vue instance context is lost and useI18n() would fail.
export function useMoreLocationsText(jobShopLocale: Ref<string | undefined>, t: ReturnType<typeof useI18n>["t"]) {
  const moreLocationsText = computed(() => {
    const locale = jobShopLocale.value
    const baseLocale = locale?.split("-")[0] || "en"
    const singularForm = t("search.more-locations", 1, { locale: baseLocale })
    const pluralForm = t("search.more-locations", 2, { locale: baseLocale })
    return singularForm === pluralForm ? singularForm : `${singularForm} | ${pluralForm}`
  })

  return { moreLocationsText }
}
